import { jsx as _jsx } from "react/jsx-runtime";
import { BoundedPortal } from '@integration-app/react';
import clsx from 'clsx';
import classes from './Backdrop.module.css';
export function Backdrop({ children, className, onClick, type = 'overlay', ...props }) {
    return (_jsx(BoundedPortal, { children: _jsx("div", { role: 'dialog', className: clsx(classes.backdrop, onClick && classes.backdrop__clickable, {
                [classes['backdrop-overlay']]: type === 'overlay',
                [classes['backdrop-blur']]: type === 'blur',
            }, className), onClick: onClick, ...props, children: children }) }));
}
//# sourceMappingURL=Backdrop.js.map